"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const night = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-night` : '') + (description ? ` desc-night` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-night"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-night"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    d: "M18.3447 0.25C10.0442 0.25 3.25 5.45998 3.25 12C3.25 18.54 10.0442 23.75 18.3447 23.75C18.912 23.75 19.4852 23.7237 20.0659 23.6725C20.8624 23.6023 21.0107 22.5006 20.2611 22.2223C15.4029 20.4184 12.2342 16.4325 12.2342 12C12.2342 7.56743 15.4031 3.58154 20.2609 1.77871C21.01 1.5007 20.863 0.400125 20.0672 0.328578C19.4892 0.276616 18.915 0.25 18.3447 0.25ZM16.6575 1.82827L16.799 1.816L16.7781 1.82902C13.0552 4.17539 10.7342 7.89889 10.7342 12L10.7383 12.2994C10.8451 16.168 13.0163 19.6757 16.4699 21.9719L16.796 22.183L16.6575 22.1717C9.91698 21.5416 4.75 17.1865 4.75 12C4.75 6.81349 9.91698 2.45837 16.6575 1.82827Z",
    fill: "inherit"
  }));
};
var _default = exports.default = night;